



















































import Vue, { VueConstructor } from 'vue'
import { mapState, mapActions } from 'vuex'
import ExportModal, {ExportModalType} from '@/components/ExportModal.vue'
import IconPlay from '@/assets/icons/icon-play.svg'
import IconPause from '@/assets/icons/icon-pause.svg'
import ChordSwitcher from '@/components/ChordSwitcher.vue'
import IconRefresh from '@/assets/icons/icon-refresh.svg'
import IconNoRefresh from '@/assets/icons/icon-no-refresh.svg'
import IconDoorExit from '@/assets/icons/icon-door-exit.svg'
import IconDocumentNotes from '@/assets/icons/icon-document-notes.svg'
import IconHeadphones from '@/assets/icons/icon-headphones.svg'
import IconDuplicate from '@/assets/icons/icon-duplicate.svg'
import IconInboxUpload from '@/assets/icons/icon-inbox-upload.svg'
import IconEar from '@/assets/icons/icon-ear.svg'
import hasBreakpoints, { HasBreakpointsMixinComputed } from '@/mixins/hasBreakpoints'
import hasPlaybackSettings, { HasPlaybackSettingsMixin } from '@/mixins/hasPlaybackSettings'
import { setBpm, setLoop, setArpeggio } from '@/application/PlaybackSettingsManager'
import _debounce from 'lodash/debounce'
import { RawLocation } from 'vue-router'

type Mixins = HasBreakpointsMixinComputed & HasPlaybackSettingsMixin

export default (Vue as VueConstructor<Mixins>).extend({
  mixins: [hasBreakpoints, hasPlaybackSettings],
  props: {
    playing: { type: Boolean },
    disablePlayback: { type: Boolean },
    canShare: { type: Boolean },
    progression: { type: Array as () => number[] }
  },
  data() {
    return {
      showNameModal: false
    }
  },
  components: {
    ExportModal,
    IconPlay,
    IconPause,
    ChordSwitcher,
    IconRefresh,
    IconNoRefresh,
    IconDoorExit,
    IconDocumentNotes,
    IconHeadphones,
    IconDuplicate,
    IconInboxUpload,
    IconEar
  },
  computed: {
    ...mapState('chordProgression', [
      'progressionName'
    ]),
    ...mapState('app', [
      'keyBindingsActive'
    ]),
    exportName: {
      get(): string {
        return this.progressionName
      },
      set(value: string) {
        this.setName(value)
      }
    },
    localArpeggio: {
      get(): boolean {
        return this.arpeggio
      },
      set(arpeggio: boolean) {
        this.updateArpeggio(arpeggio)
      }
    },
    keymap(): Keymap {
      // We want space to toggle play and not trigger focused elements. UNLESS the modal is showing in which case we need to be
      // able to type spaces as normal
      return this.keyBindingsActive ? {
        'space': event => {
          event.preventDefault()
          this.toggle()
        }
      } : {}
    },
    earTrainingLink(): RawLocation {
      const fourChords = this.progression.slice(0, 4)
      return {
        name: 'Training',
        query: {
          degrees: fourChords.join(',')
        }
      }
    }
  },
  methods: {
    ...mapActions('chordProgression', [
      'setName'
    ]),
    ...mapActions('app', [
      'setKeyBindingsActive'
    ]),
    toggle() {
      this.$emit('toggle')
    },
    showModal(onSave: () => void) {
      (this.$refs.exportModal as unknown as ExportModalType).show(this.progressionName, (name: string) => {
        this.setName(name)
        Vue.nextTick(() => onSave())
      })
    },
    share() {
      this.$emit('share')
    },
    copy() {
      this.$emit('copy')
    },
    download() {
      this.showModal(() => { this.$emit('download') })
    },
    print() {
      this.showModal(() => { this.$emit('print') })
    },
    updateBpm: _debounce(function (this: any, bpm: number) {
      if (bpm === this.bpm) return
      setBpm(this.$route, this.$router, bpm)
    }, 100),
    updateLoop(loop: boolean) {
      if (loop === this.loop) return
      setLoop(this.$route, this.$router, loop)
    },
    updateArpeggio(arpeggio: boolean) {
      if (arpeggio == this.arpeggio) return
      setArpeggio(this.$route, this.$router, arpeggio)
    }
  }
})
